import React from "react";
import { ConfirmDialogControl } from "../../hooks/useConfirmDialog";
import { ExtraChangeBlockedDialog } from "./ExtraChangeBlockedDialog";
import { ExtraChangeBlockedView, ExtraImpactDialogView } from "./extraImpactDialog.viewModel";
import { ExtraImpactDialog } from "./ExtraImpactDialog";

export interface ExtraChangeDialogsProps {
  readonly impact: ConfirmDialogControl<ExtraImpactDialogView>;
  readonly blocked: ConfirmDialogControl<ExtraChangeBlockedView>;
}

/** Both dialogs of `useExtraChangeGuard`; render it once on the page that uses the guard. */
export function ExtraChangeDialogs({ impact, blocked }: ExtraChangeDialogsProps) {
  return (
    <>
      <ExtraImpactDialog {...impact} />
      <ExtraChangeBlockedDialog {...blocked} />
    </>
  );
}
